
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bprG4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $dh538 = parcelRequire("dh538");


var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $3AFGg = parcelRequire("3AFGg");


var $6Zbgf = parcelRequire("6Zbgf");


var $jJ2Ec = parcelRequire("jJ2Ec");


var $4u5NT = parcelRequire("4u5NT");

function $1815e29262ceb766$var$getLateMutations(vcDetails, labelStacks = {}, lastInteractionFinish, postInteractionFinishVCRatios) {
    // Map to track which elements are already seen for each timestamp
    const seen = new Map();
    const result = [];
    for(const part in vcDetails){
        const details = vcDetails[part];
        if (!details?.t || details.t <= lastInteractionFinish.end || !details.e) continue; // Skip if not late or no elements
        if (!seen.has(details.t)) seen.set(details.t, new Set());
        const seenElements = seen.get(details.t);
        for (const element of details.e){
            if (seenElements.has(element)) continue;
            seenElements.add(element);
            const lateMutation = {
                time: details.t,
                element: element,
                viewportHeatmapPercentage: postInteractionFinishVCRatios?.[element] || 0
            };
            if (labelStacks) {
                const labels = labelStacks[element];
                if (labels && typeof labels !== 'string') {
                    lateMutation.segment = labels.segment;
                    lateMutation.labelStack = labels.labelStack;
                }
            }
            result.push(lateMutation);
        }
    }
    return result;
}
var $1815e29262ceb766$export$2e2bcd8739ae039 = $1815e29262ceb766$var$getLateMutations;


function $c9aade11775a0fcd$var$getParentStack(labelStack) {
    if (!labelStack || labelStack.length <= 1) return null;
    return labelStack.slice(0, labelStack.length - 1);
}
function $c9aade11775a0fcd$var$getSegmentId(labelStack) {
    if (!labelStack) return null;
    const leafLabelStack = labelStack[labelStack.length - 1];
    if ((0, $3AFGg.isSegmentLabel)(leafLabelStack)) return leafLabelStack.segmentId;
    const parentStack = $c9aade11775a0fcd$var$getParentStack(labelStack);
    if (!parentStack) return null;
    return $c9aade11775a0fcd$var$getSegmentId(parentStack);
}
function $c9aade11775a0fcd$var$getParentSegmentId(labelStack) {
    return $c9aade11775a0fcd$var$getSegmentId($c9aade11775a0fcd$var$getParentStack(labelStack));
}
/**
 * Whenever a render happen, all parent segment have timing reported
 * This method tries to reduce that noise
 */ function $c9aade11775a0fcd$var$removeCascadingParentTimingReport(reactProfilerTimings) {
    const timingIndex = new Map();
    reactProfilerTimings.forEach((timing)=>{
        const segmentId = $c9aade11775a0fcd$var$getSegmentId(timing.labelStack);
        if (segmentId) {
            const timingArray = timingIndex.get(segmentId) ?? [];
            timingIndex.set(segmentId, timingArray);
            timingArray.push(timing);
        }
    });
    reactProfilerTimings.forEach((timing)=>{
        const parentSegmentId = $c9aade11775a0fcd$var$getParentSegmentId(timing.labelStack);
        if (parentSegmentId) {
            const parentTimings = timingIndex.get(parentSegmentId);
            const filteredParentTimings = parentTimings?.filter((parentTiming)=>{
                return !(parentTiming.startTime === timing.startTime && parentTiming.actualDuration === timing.actualDuration);
            });
            if (filteredParentTimings) timingIndex.set(parentSegmentId, filteredParentTimings);
            else timingIndex.delete(parentSegmentId);
        }
    });
    return [
        ...timingIndex.values()
    ].flatMap((v)=>v);
}
function $c9aade11775a0fcd$var$transformReactProfilerTimings(reactProfilerTimings) {
    const filtered = $c9aade11775a0fcd$var$removeCascadingParentTimingReport(reactProfilerTimings ?? []);
    const reactProfilerTimingsMap = filtered.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && type !== 'nested-update') {
            const label = labelStack.map((ls)=>ls.name).join('/');
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const cacheKey = (0, $3AFGg.stringifyLabelStackFully)(labelStack);
            const timing = result.get(label) || {
                labelStack: label,
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 1,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = Math.round(start);
            if (end > timing.endTime) timing.endTime = Math.round(end);
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $4u5NT.segmentUnmountCache).has(cacheKey) && (0, $dh538.fg)('platform_ufo_segment_unmount_count')) {
                timing.unmountCount = (0, $4u5NT.segmentUnmountCache).get(cacheKey) || 0;
                (0, $4u5NT.segmentUnmountCache).delete(cacheKey);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}
function $c9aade11775a0fcd$var$createPostInteractionLogPayload({ lastInteractionFinish: lastInteractionFinish, reactProfilerTimings: reactProfilerTimings, lastInteractionFinishVCResult: lastInteractionFinishVCResult, postInteractionFinishVCResult: postInteractionFinishVCResult, postInteractionHoldInfo: postInteractionHoldInfo }) {
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    if (!lastInteractionFinish) return null;
    const ufoName = (0, $3AFGg.sanitizeUfoName)(lastInteractionFinish.ufoName);
    const rate = (0, $53d5Q.getPostInteractionRate)(ufoName, lastInteractionFinish.type);
    if (!(0, $1haRI.default)(rate)) return null;
    if ((0, $dh538.fg)('platform_ufo_disable_ufo_names_config')) {
        const config = (0, $53d5Q.getConfig)();
        if (config?.disabledUfoNames && config?.disabledUfoNames.includes(ufoName)) return null;
    }
    const pageVisibilityState = (0, $jJ2Ec.getPageVisibilityState)(lastInteractionFinish.start, lastInteractionFinish.end);
    if (pageVisibilityState !== 'visible') return null;
    // Align post-interaction-logs closer to UFO event behaviour,
    // e.g. also check for aborted or failed events
    if (lastInteractionFinish.abortReason) return null;
    if (lastInteractionFinish.errors.length > 0) return null;
    const maxEndTimeFromProfiler = reactProfilerTimings && reactProfilerTimings.length > 0 ? Math.max(...reactProfilerTimings.map((t)=>t.commitTime)) : lastInteractionFinish.end;
    const revisedEndTime = Math.round(maxEndTimeFromProfiler);
    const revisedTtai = Math.round(maxEndTimeFromProfiler - lastInteractionFinish.start);
    const lastInteractionFinishStart = Math.round(lastInteractionFinish.start);
    const lastInteractionFinishEnd = Math.round(lastInteractionFinish.end);
    const lastInteractionFinishTTAI = Math.round(lastInteractionFinish.end - lastInteractionFinish.start);
    const mostRecentVCRevision = (0, $53d5Q.getMostRecentVCRevision)(lastInteractionFinish.ufoName) ?? (0, $53d5Q.DEFAULT_TTVC_REVISION);
    let lastInteractionFinishVC90 = null;
    let lastInteractionFinishVCClean = false;
    const lastInteractionFinishVCRev = lastInteractionFinishVCResult?.['ufo:vc:rev'];
    const lastInteractionFinishRevision = lastInteractionFinishVCRev?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (lastInteractionFinishRevision?.clean) {
        lastInteractionFinishVCClean = true;
        lastInteractionFinishVC90 = lastInteractionFinishRevision['metric:vc90'] ?? null;
    }
    let postInteractionFinishVCRatios = {};
    let postInteractionFinishVCClean = false;
    let revisedVC90 = null;
    let lateMutations = [];
    const postInteractionFinishVCRev = postInteractionFinishVCResult?.['ufo:vc:rev'];
    const postInteractionFinishRevision = postInteractionFinishVCRev?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (postInteractionFinishRevision?.clean) {
        postInteractionFinishVCClean = true;
        postInteractionFinishVCRatios = postInteractionFinishRevision.ratios;
        if (typeof lastInteractionFinishVC90 === 'number') revisedVC90 = postInteractionFinishRevision['metric:vc90'] ?? null;
        const vcDetails = postInteractionFinishRevision.vcDetails;
        const labelStacks = postInteractionFinishRevision.labelStacks;
        if (vcDetails) lateMutations = (0, $1815e29262ceb766$export$2e2bcd8739ae039)(vcDetails, labelStacks, lastInteractionFinish, postInteractionFinishVCRatios);
    }
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $6Zbgf.getReactUFOPayloadVersion)(lastInteractionFinish.type, true)
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.post-interaction-logs',
                postInteractionLog: {
                    lastInteractionFinish: {
                        ...lastInteractionFinish,
                        ufoName: ufoName,
                        start: lastInteractionFinishStart,
                        end: lastInteractionFinishEnd,
                        ttai: lastInteractionFinishTTAI,
                        vc90: lastInteractionFinishVC90,
                        vcClean: lastInteractionFinishVCClean
                    },
                    revisedEndTime: revisedEndTime,
                    revisedTtai: revisedTtai,
                    revisedVC90: revisedVC90,
                    vcClean: postInteractionFinishVCClean,
                    lateMutations: lateMutations,
                    reactProfilerTimings: $c9aade11775a0fcd$var$transformReactProfilerTimings(reactProfilerTimings),
                    ...(0, $dh538.fg)('platform_ufo_enable_late_holds_post_interaction') ? {
                        postInteractionHoldInfo: postInteractionHoldInfo?.map((hold)=>({
                                ...hold,
                                labelStack: hold.labelStack.map((label)=>label.name).join('/')
                            }))
                    } : {}
                }
            }
        }
    };
}
var $c9aade11775a0fcd$export$2e2bcd8739ae039 = $c9aade11775a0fcd$var$createPostInteractionLogPayload;
module.exports["default"] = $c9aade11775a0fcd$export$2e2bcd8739ae039;

});


//# sourceMappingURL=create-post-interaction-log-payload.ef667dec.js.map
